import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { ListItemText } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Arbitrator from '../../components/Arbitrator';
import axios from 'axios';
import PropTypes from 'prop-types';
import ChooseArbitratorDialog from './ChooseArbitratorDialog';
import ChooseArbitratorDialogRespondent from './ChooseArbitratorDialogRespondent';


const styles = theme => ({
    root: {
        display: 'flex',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
        justifyContent:'center'
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        margin: theme.spacing.unit * 3,
    },
});

class ChooseArbitratorAdmin extends Component {
    state = {
      value: this.props.claimantUniqueId,
      open: false,
      open_: true,
      uniqueId: localStorage.getItem('token'),
    };

    componentDidMount(){
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getCaseInfo`;
        let payload = {
            caseId: this.props.caseId,
        }
        axios.post(url, payload)
        .then((response) => {
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            this.setState({value: response.data.claimantArbitrator});

        })
        .catch((error) => {
            console.log(error);
        });

        setInterval(()=>{
            // if (this.props.lang == 'en'){
                this.props.getArbitrators(localStorage.getItem('token'));
            // }
            // else{
            //     this.props.getArbitratorsChi(localStorage.getItem('token'));
            // }
        },1000)
    }

    handleChange = event => {
        this.setState({
            value: event.target.value,
             open: true,
        });
    }

    handleComplete = () =>{
        window.location.reload()
    }

    setArbitrators = () => {
        this.props.setArbitratorsAdmin(this.props.caseId, this.state.value, this.handleComplete);
    }


    toggleOpen = () => {
        this.setState( (prevState) => ({
            open: !prevState.open,
        }) );
      }

      toggleOpen_ = () => {
        this.setState( (prevState) => ({
            open_: !prevState.open_,
        }) );
      }

    render(){
        const { classes, isLoading, arbitrators } = this.props;
        var lang = localStorage.getItem('language');
        if(isLoading){
            return(
                <CircularProgress size={50} thickness={3} className={classes.progress}/>
            );
        }
        return(
            <div className={classes.root}>
            <label style={{ fontSize: '14px'}} >Admin, Please assign the arbitrator for this case.</label>
                <FormControl component='fieldset' className={classes.formControl}>
                    <ChooseArbitratorDialog open={this.state.open} toggleOpen={this.toggleOpen} setArbitrators={this.setArbitrators} claimantArbitratorName={this.props.claimantArbitratorName} respondentArbitratorName={this.props.respondentArbitratorName} claimantUniqueId={this.props.claimantUniqueId} respondentUniqueId={this.props.respondentUniqueId} uniqueId={this.state.uniqueId}  />
                    <RadioGroup
                        name='chooseArbitrator'
                        className={classes.group}
                        value={this.state.value}
                        onChange={this.handleChange}
                    >
                    {
                        arbitrators.map((arbitrator, index) => (
                            <FormControlLabel
                                key={index}
                                value={arbitrator.arbitratorId}
                                label={<Arbitrator 
                                            firstName={arbitrator.firstname}
                                            lastName={arbitrator.lastname}
                                            occupation={arbitrator.occupation}
                                            jurisdiction={arbitrator.jurisdiction}
                                            expertise={arbitrator.expertise}
                                            lang = {lang}
                                            arbitratorId={arbitrator.arbitratorId}
                                            firstName_chi={arbitrator.firstname_chi}
                                            lastName_chi={arbitrator.lastname_chi}
                                            occupation_chi={arbitrator.occupation_chi}
                                            jurisdiction_chi={arbitrator.jurisdiction_chi}
                                            expertise_chi={arbitrator.expertise_chi}
                                            arbitrator={this.context.t('arbitrator')}
                                            arbitratorProfile={this.context.t('arbitratorProfile')}
                                            jurisdictions={ this.context.t('Jurisdiction') }
                                            occupations={ this.context.t('Occupation') }
                                        />}
                                control={<Radio key={index}
                                classes={{root: classes.radio, checked: classes.checked}}/>}
                            />
                        ))
                    }
                    </RadioGroup>
                </FormControl>
            </div>
        )
        

       
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.arbitrator.loading,
        arbitrators: state.arbitrator.arbitrators,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimantArbitratorName: state.caseInfo.claimantArbitratorName,
        respondentArbitratorName: state.caseInfo.respondentArbitratorName,
        lang: state.i18nState.lang,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getArbitrators: () => dispatch(actions.arbitrators()),
        getArbitratorsChi: () => dispatch(actions.arbitratorsChi()),
        setArbitratorsAdmin: (caseId, arbitratorId, handleComplete) => dispatch(actions.setArbitratorsAdmin(caseId, arbitratorId, handleComplete)),
    }
}

ChooseArbitratorAdmin.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ChooseArbitratorAdmin)));
